function mtInitReveal() {
  var els = document.querySelectorAll(".mt-reveal:not(.mt-visible)");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) {
    els.forEach(function (el) { el.classList.add("mt-visible"); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("mt-visible");
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
  );
  els.forEach(function (el) { io.observe(el); });
}

document.addEventListener("DOMContentLoaded", function () {
  mtInitReveal();
});
document.addEventListener("shopify:section:load", function () {
  mtInitReveal();
});
